import { notFound } from 'next/navigation'
import { FEATURE_FLAGS, displayFeature } from './feature-flags'

/**
 * Server-side utility to check if a feature flag is enabled
 * If the feature is not enabled, redirects to the fallback path
 */
export function checkFeatureFlag(featureFlag: FEATURE_FLAGS): boolean {
  const isFeatureEnabled = displayFeature(featureFlag)

  if (!isFeatureEnabled) {
    notFound()
  }

  return true
}
